import React, { createContext, useContext } from 'react';

const SubscriptionContext = createContext(null);

// Mock SubscriptionProvider - no backend functionality
export const SubscriptionProvider = ({ children }) => {
  const value = {
    profile: null,
    userProfile: null,
    usage: null,
    isAdmin: false,
    loading: false,
    profileLoading: false,
    subscriptionLoading: false,
    refreshProfile: async () => {},
    canUseFeature: () => false,
  };

  return (
    <SubscriptionContext.Provider value={value}>
      {children}
    </SubscriptionContext.Provider>
  );
};

export const useSubscription = () => {
  const context = useContext(SubscriptionContext);
  if (context === undefined) {
    throw new Error('useSubscription must be used within a SubscriptionProvider');
  }
  return context;
};
